<template>
  <div :class="componentClassName">
    <div class="o-special-business-day-setting-list__items">
      <template v-for="(item, index) in items" :key="index">
        <m-special-business-day-setting-item
          v-model="items[index].day"
          v-model:periods="items[index].periods"
          v-model:is24hours="items[index].is24hours"
          :item-index="index"
          @remove="removeItem(index)"
        />
      </template>
    </div>
    <div class="o-special-business-day-setting-list__control">
      <a-button
        :inline="true"
        variant="fill"
        color="primary"
        size="small"
        icon="plus"
        icon-color="white"
        label="特別営業日追加"
        @click="handleAddItem"
      />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import MSpecialBusinessDaySettingItem from '@/components/molecules/special-business-day-setting-item';
import AButton from '@/components/atoms/button';
import { cloneDeep } from 'lodash';

export default {
  name: 'o-special-business-day-setting-list',
  components: {
    MSpecialBusinessDaySettingItem,
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [String, Object],
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      items: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-special-business-day-setting-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    items: {
      handler(val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.emitEvent();
        }
      },
      deep: true,
    },
    modelValue: {
      handler(val) {
        this.setCurrentValue(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.modelValue) {
      this.setCurrentValue(this.modelValue);
    } else {
      this.setCurrentValue([
        {
          day: '',
          is24hours: false,
          periods: [],
        },
      ]);
    }
  },
  methods: {
    handleAddItem() {
      this.items.push({
        day: '',
        is24hours: false,
        periods: [],
      });
      this.emitEvent();
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.emitEvent();
    },
    setCurrentValue(val) {
      this.items.splice(0);
      if (Array.isArray(val)) {
        val.forEach(item => {
          this.items.push(item);
        });
      }
    },
    emitEvent() {
      this.$emit('update:modelValue', cloneDeep(this.items));
    },
  },
};
</script>
